/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashfix_Error_Result_ExpiredInputs */

const en_dashfix_error_result_expired = /** @type {(inputs: Dashfix_Error_Result_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The completed result is no longer available.`)
};

const zh_hans1_dashfix_error_result_expired = /** @type {(inputs: Dashfix_Error_Result_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成的结果已不可用。`)
};

const pt_br2_dashfix_error_result_expired = /** @type {(inputs: Dashfix_Error_Result_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O resultado concluído não está mais disponível.`)
};

const es_dashfix_error_result_expired = /** @type {(inputs: Dashfix_Error_Result_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El resultado completado ya no está disponible.`)
};

const fr_dashfix_error_result_expired = /** @type {(inputs: Dashfix_Error_Result_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le résultat terminé n’est plus disponible.`)
};

const de_dashfix_error_result_expired = /** @type {(inputs: Dashfix_Error_Result_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das abgeschlossene Ergebnis ist nicht mehr verfügbar.`)
};

const ru_dashfix_error_result_expired = /** @type {(inputs: Dashfix_Error_Result_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готовый результат больше недоступен.`)
};

const it_dashfix_error_result_expired = /** @type {(inputs: Dashfix_Error_Result_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il risultato completato non è più disponibile.`)
};

/**
* | output |
* | --- |
* | "The completed result is no longer available." |
*
* @param {Dashfix_Error_Result_ExpiredInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const dashfix_error_result_expired = /** @type {((inputs?: Dashfix_Error_Result_ExpiredInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashfix_Error_Result_ExpiredInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_dashfix_error_result_expired(inputs)
	if (locale === "pt-BR") return pt_br2_dashfix_error_result_expired(inputs)
	if (locale === "es") return es_dashfix_error_result_expired(inputs)
	if (locale === "fr") return fr_dashfix_error_result_expired(inputs)
	if (locale === "de") return de_dashfix_error_result_expired(inputs)
	if (locale === "ru") return ru_dashfix_error_result_expired(inputs)
	if (locale === "it") return it_dashfix_error_result_expired(inputs)
	return en_dashfix_error_result_expired(inputs)
});